import { render, staticRenderFns } from "./UploadVideoModal.vue?vue&type=template&id=d739126c&"
import script from "./UploadVideoModal.vue?vue&type=script&lang=ts&"
export * from "./UploadVideoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1212067952/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d739126c')) {
      api.createRecord('d739126c', component.options)
    } else {
      api.reload('d739126c', component.options)
    }
    module.hot.accept("./UploadVideoModal.vue?vue&type=template&id=d739126c&", function () {
      api.rerender('d739126c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/modals/UploadVideoModal.vue"
export default component.exports